const IRKUTSK_TIMEZONE = "Asia/Irkutsk";

function normalizeToIso(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  // Если offset не указан, считаем, что это UTC-метка от backend.
  if (/^\d{4}-\d{2}-\d{2}T/.test(raw) && !/(Z|[-+]\d{2}:\d{2})$/.test(raw)) {
    return `${raw}Z`;
  }
  return raw;
}

export function formatIrkutskDateTime(value) {
  const iso = normalizeToIso(value);
  if (!iso) return "";
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleString("ru-RU", {
    timeZone: IRKUTSK_TIMEZONE,
  });
}

export function formatIrkutskDate(value) {
  const iso = normalizeToIso(value);
  if (!iso) return "";
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleDateString("ru-RU", {
    timeZone: IRKUTSK_TIMEZONE,
  });
}

// Для значений без timezone, которые уже сохранены как локальное иркутское время
// (например raffle_draw_at из админки), показываем без повторного пересчёта.
export function formatIrkutskLocalDateTime(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const normalized = raw.replace("T", " ");
  if (!normalized) return "";
  return normalized.length >= 16 ? normalized.slice(0, 16) : normalized;
}
